export const LOGIN = "user/LOGIN";
export const FACEBOOK_LOGIN = "user/FACEBOOK_LOGIN";
export const GOOGLE_LOGIN = "user/GOOGLE_LOGIN";
export const GET_USER = "user/GET_USER";
export const LOGOUT = "user/LOGOUT";
export const RESET_USER = "user/RESET_USER";
export const EDIT_USER = "user/EDIT_USER";
export const NOTICE_SETTINGS = "user/NOTICE_SETTINGS";
